import { Link } from "react-router-dom";
import { useApp } from "../app/AppContext.jsx";
import { api } from "../lib/api.js";
import { useFetch } from "../lib/useFetch.js";
import CarCard, { CarCardSkeleton } from "../components/CarCard.jsx";
import { num } from "../lib/format.js";

export default function Home() {
  const { t, country, countryName, lang } = useApp();
  const { data: stats } = useFetch(() => api.stats(), "stats");
  const { data: featured, loading } = useFetch(
    () => api.listings({ country, perPage: 8, sort: "newest", withPhotos: "1", facets: "0" }),
    `featured:${country}`
  );

  return (
    <>
      <section className="wrap" style={{ paddingBlock: "clamp(56px,10vw,120px) clamp(40px,6vw,80px)" }}>
        <p className="eyebrow">{t("home.eyebrow")}</p>
        <h1 className="h1" style={{ marginTop: 20, maxWidth: 16 + "ch" }}>{t("home.title")}</h1>
        <p className="muted" style={{ marginTop: 22, maxWidth: "58ch", fontSize: 16, lineHeight: 1.75 }}>
          {t("home.sub", { country: countryName })}
        </p>

        <div style={{ display: "flex", gap: 12, marginTop: 34, flexWrap: "wrap" }}>
          <Link className="btn btn--solid" to="/stock">{t("home.cta")}</Link>
          <Link className="btn btn--ghost" to="/import-calculator">{t("home.cta2")}</Link>
        </div>

        {stats && (
          <div className="grid grid--4" style={{ marginTop: 60, maxWidth: 760 }}>
            <Stat n={num(stats.active, lang)} label={t("home.stat.cars")} />
            <Stat n={num(stats.makes, lang)} label={t("home.stat.makes")} />
            <Stat n={String(stats.byOrigin?.length || 0)} label={t("home.stat.markets")} />
            {stats.soldLast90d?.avgDays > 0 && (
              <Stat n={`${stats.soldLast90d.avgDays}d`} label={t("home.stat.days")} />
            )}
          </div>
        )}
      </section>

      <section className="wrap" style={{ paddingBlock: "clamp(40px,6vw,70px)", borderTop: "1px solid var(--line)" }}>
        <p className="label">{t("home.why.title")}</p>
        <div className="grid grid--3" style={{ marginTop: 32 }}>
          <Why title={t("home.why.kr.title")} body={t("home.why.kr.body")} n="01" />
          <Why title={t("home.why.jp.title")} body={t("home.why.jp.body")} n="02" />
          <Why title={t("home.why.price.title")} body={t("home.why.price.body")} n="03" />
        </div>
      </section>

      <section className="wrap" style={{ paddingBlock: "clamp(40px,6vw,70px) clamp(60px,9vw,110px)", borderTop: "1px solid var(--line)" }}>
        <div className="page__head">
          <div>
            <p className="label">{t("home.featured")}</p>
            <h2 className="h2" style={{ marginTop: 12 }}>{t("car.landedIn", { country: countryName })}</h2>
          </div>
          <Link className="btn btn--ghost btn--sm" to="/stock">{t("home.featuredAll")}</Link>
        </div>

        <div className="grid grid--cars">
          {loading
            ? Array.from({ length: 4 }, (_, i) => <CarCardSkeleton key={i} />)
            : featured?.results?.map((l, i) => <CarCard key={l.id} listing={l} quote={l.quote} priority={i < 4} />)}
        </div>
      </section>
    </>
  );
}

const Stat = ({ n, label }) => (
  <div>
    <div style={{ fontFamily: "var(--display)", fontSize: 30, color: "var(--accent)" }}>{n}</div>
    <div className="tiny muted" style={{ marginTop: 6, textTransform: "uppercase", letterSpacing: "0.16em" }}>{label}</div>
  </div>
);

const Why = ({ title, body, n }) => (
  <div className="step-card">
    <div className="step-card__n">{n}</div>
    <h3 className="h3" style={{ margin: "12px 0 10px" }}>{title}</h3>
    <p className="muted small" style={{ lineHeight: 1.75 }}>{body}</p>
  </div>
);
